// Panel admin para editar el bloque fijo institucional que se anexa al final
// de TODA descripción ML. Vive en app_config.ml_descripcion_fija como array jsonb.
// ML no acepta emoticonos — los inputs avisan si hay y los limpian al guardar.

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import AdminLayout from '../../components/AdminLayout'

const REGEX_EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{1F000}-\u{1F02F}\u{2700}-\u{27BF}\u{1F100}-\u{1F1FF}\u{1F200}-\u{1F2FF}]/gu
// ML penaliza URLs, emails y números de teléfono que apuntan a contacto fuera de plataforma
const REGEX_URL = /(?:https?:\/\/|www\.|\b[a-z0-9-]+\.(?:com|uy|net|org|io|co|cl|ar|br|app|me|info|biz))[^\s]*/gi
const REGEX_EMAIL = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
const REGEX_TELEFONO = /(?:\+?\d{1,3}[\s\-.]?)?(?:\(\d{2,4}\)[\s\-.]?)?\d{6,}(?:[\s\-.]\d{2,5}){0,3}/g

function tieneEmoji(s) { return REGEX_EMOJI.test(s || '') }
function sacarEmojis(s) { return (s || '').replace(REGEX_EMOJI, '').replace(/\s+\n/g, '\n').trim() }
function tieneURL(s) { return REGEX_URL.test(s || '') }
function tieneEmail(s) { return REGEX_EMAIL.test(s || '') }
function tieneTelefono(s) {
  // descartar matches que sean precios ("$1.000", "9:00 a 18:00")
  const limpio = (s || '').replace(/\$\s*\d[\d.,]*/g, '').replace(/\d{1,2}:\d{2}/g, '')
  return REGEX_TELEFONO.test(limpio)
}

export default function DescripcionFijaML() {
  const [bloques, setBloques] = useState([])
  const [bloquesOriginales, setBloquesOriginales] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => { cargar() }, [])

  async function cargar() {
    setLoading(true)
    const { data } = await supabase.from('app_config').select('value').eq('key', 'ml_descripcion_fija').maybeSingle()
    let v = []
    if (data?.value) {
      const parsed = typeof data.value === 'string' ? JSON.parse(data.value) : data.value
      if (Array.isArray(parsed)) v = parsed
    }
    setBloques(v)
    setBloquesOriginales(v)
    setLoading(false)
  }

  function actualizar(idx, texto) {
    setBloques(bloques.map((b, i) => i === idx ? texto : b))
  }

  function mover(idx, dir) {
    const target = idx + dir
    if (target < 0 || target >= bloques.length) return
    const nuevo = [...bloques]
    ;[nuevo[idx], nuevo[target]] = [nuevo[target], nuevo[idx]]
    setBloques(nuevo)
  }

  function quitar(idx) {
    if (!confirm('¿Quitar este bloque?')) return
    setBloques(bloques.filter((_, i) => i !== idx))
  }

  function agregar() {
    setBloques([...bloques, 'TÍTULO\nTexto del bloque...'])
  }

  async function guardar() {
    setSaving(true); setMsg(null)
    // Limpieza: sacar emojis + trim cada bloque
    const limpios = bloques.map(sacarEmojis).filter(b => b.length > 0)
    const { error } = await supabase.from('app_config').upsert({
      key: 'ml_descripcion_fija',
      value: limpios,
    }, { onConflict: 'key' })
    if (error) {
      setMsg({ ok: false, txt: 'Error: ' + error.message })
    } else {
      setBloques(limpios)
      setBloquesOriginales(limpios)
      setMsg({ ok: true, txt: '✓ Guardado. Se aplica a la próxima sincronización ML.' })
    }
    setSaving(false)
  }

  function descartar() {
    setBloques(bloquesOriginales)
    setMsg(null)
  }

  const haCambios = JSON.stringify(bloques) !== JSON.stringify(bloquesOriginales)
  const textoCompleto = bloques.join('\n\n')
  const charsTotal = textoCompleto.length
  const hayEmojis = bloques.some(tieneEmoji)

  return (
    <AdminLayout>
      <div className="page">
        <Link to="/admin/canales/mercadolibre" style={{ fontSize: 13, color: 'var(--muted)' }}>← Volver a MercadoLibre</Link>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
          <div>
            <h1 style={{ margin: 0 }}>📝 Bloque fijo de la descripción ML</h1>
            <p className="lead" style={{ margin: '4px 0 0', maxWidth: 720 }}>
              Texto institucional que se anexa al final de <strong>toda publicación ML</strong>. Editás acá una vez y se aplica a todos los productos cuando los sincronizás.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {haCambios && (
              <button className="btn ghost" onClick={descartar} disabled={saving} style={{ fontSize: 12 }}>
                Descartar
              </button>
            )}
            <button
              onClick={guardar}
              disabled={saving || !haCambios}
              style={{
                background: haCambios ? '#1A3461' : '#CBD5E1', color: '#fff', border: 'none',
                padding: '8px 16px', borderRadius: 8, fontWeight: 700, fontSize: 13,
                cursor: haCambios && !saving ? 'pointer' : 'not-allowed',
              }}
            >
              {saving ? 'Guardando…' : haCambios ? 'Guardar' : 'Sin cambios'}
            </button>
          </div>
        </div>

        {msg && (
          <div style={{
            marginTop: 14, padding: '10px 14px', borderRadius: 8,
            background: msg.ok ? '#DCFCE7' : '#FEE2E2',
            color: msg.ok ? '#166534' : '#7F1D1D',
            fontSize: 13, fontWeight: 600,
          }}>{msg.txt}</div>
        )}

        {hayEmojis && (
          <div style={{ marginTop: 14, padding: '10px 14px', background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 8, color: '#92400E', fontSize: 13 }}>
            ⚠ Hay emoticones en al menos un bloque. ML los penaliza — al guardar se eliminan automáticamente.
          </div>
        )}

        {loading ? (
          <div className="card" style={{ marginTop: 18, color: 'var(--muted)' }}>Cargando…</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 18, marginTop: 18 }}>
            {/* Editor */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <strong style={{ fontSize: 13, color: '#1A3461' }}>{bloques.length} secciones · {charsTotal.toLocaleString('es-UY')} caracteres totales</strong>
                <button onClick={agregar} style={{
                  background: '#10B981', color: '#fff', border: 'none',
                  padding: '6px 12px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer',
                }}>+ Agregar bloque</button>
              </div>

              {bloques.length === 0 && (
                <div className="card" style={{ color: 'var(--muted)' }}>
                  No hay bloques cargados. Tocá "+ Agregar bloque" para empezar.
                </div>
              )}

              {bloques.map((b, i) => {
                const conEmoji = tieneEmoji(b)
                const conURL = tieneURL(b)
                const conEmail = tieneEmail(b)
                const conTel = tieneTelefono(b)
                const tieneAlerta = conEmoji || conURL || conEmail || conTel
                return (
                  <div key={i} style={{
                    background: '#fff', border: `1px solid ${tieneAlerta ? '#FCD34D' : '#E2E8F0'}`,
                    borderRadius: 10, padding: 14, marginBottom: 10,
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 4 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, color: '#94A3B8', letterSpacing: '.06em', textTransform: 'uppercase', fontWeight: 700, flexWrap: 'wrap' }}>
                        <span>Bloque {i + 1}</span>
                        {conEmoji && <span style={{ color: '#92400E' }}>⚠ emoji</span>}
                        {conURL && <span style={{ color: '#7F1D1D' }}>⚠ URL (ML penaliza)</span>}
                        {conEmail && <span style={{ color: '#7F1D1D' }}>⚠ email (ML penaliza)</span>}
                        {conTel && <span style={{ color: '#7F1D1D' }}>⚠ teléfono (ML penaliza)</span>}
                      </div>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {i > 0 && (
                          <button onClick={() => mover(i, -1)} title="Subir" style={{ width: 26, height: 26, border: '1px solid #CBD5E1', background: '#fff', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>↑</button>
                        )}
                        {i < bloques.length - 1 && (
                          <button onClick={() => mover(i, 1)} title="Bajar" style={{ width: 26, height: 26, border: '1px solid #CBD5E1', background: '#fff', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>↓</button>
                        )}
                        <button onClick={() => quitar(i)} title="Quitar" style={{ width: 26, height: 26, border: '1px solid #FCA5A5', background: '#FEF2F2', color: '#991B1B', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>×</button>
                      </div>
                    </div>
                    <textarea
                      value={b}
                      onChange={e => actualizar(i, e.target.value)}
                      rows={Math.max(4, (b.match(/\n/g) || []).length + 2)}
                      style={{
                        width: '100%', padding: '10px 12px',
                        border: '1px solid #CBD5E1', borderRadius: 6,
                        fontSize: 13, fontFamily: 'inherit', resize: 'vertical',
                        boxSizing: 'border-box',
                      }}
                    />
                    <div style={{ marginTop: 4, fontSize: 10.5, color: '#94A3B8' }}>{b.length} caracteres</div>
                  </div>
                )
              })}
            </div>

            {/* Preview */}
            <div>
              <strong style={{ fontSize: 11, color: '#1A3461', fontWeight: 800, letterSpacing: '.06em', textTransform: 'uppercase', display: 'block', marginBottom: 8 }}>
                Preview · cómo se ve en ML
              </strong>
              <div style={{
                position: 'sticky', top: 16,
                background: 'linear-gradient(180deg, #FFF7E6 0%, #fff 100%)',
                border: '1px solid #FDE68A', borderRadius: 12, padding: 14,
                fontSize: 12, color: '#1F2937', lineHeight: 1.55,
                whiteSpace: 'pre-wrap',
                maxHeight: '70vh', overflow: 'auto',
              }}>
                <div style={{ marginBottom: 12, padding: '8px 10px', background: '#fff', borderRadius: 6, border: '1px dashed #FCD34D', fontSize: 11, color: '#92400E', fontStyle: 'italic' }}>
                  [Descripción específica del producto — la escribe Nico en cada ficha]
                </div>
                {textoCompleto || <span style={{ color: '#94A3B8', fontStyle: 'italic' }}>(Sin bloques)</span>}
              </div>
              <div style={{ marginTop: 10, fontSize: 10.5, color: '#94A3B8', lineHeight: 1.5 }}>
                💡 Lo de arriba (cuadro punteado) lo escribe Nico por producto. Lo de abajo se anexa automático a toda publicación ML.
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  )
}
